import { fieldsNames } from '../../constants';

import { parseCardNumber, formatCardNumber } from './cardNumber';
import { parseCardHolder, formatCardHolder } from './cardHolder';
import { parseMonth, formatMonth } from './month';
import { parseYear, formatYear } from './year';
import { transformCVV } from './cvv';

export const transforms = {
  [fieldsNames.cardNumber]: {
    parse: parseCardNumber,
    format: formatCardNumber,
  },
  [fieldsNames.cardHolder]: {
    parse: parseCardHolder,
    format: formatCardHolder,
  },
  [fieldsNames.cvv]: {
    parse: transformCVV,
    format: transformCVV,
  },
  [fieldsNames.month]: {
    parse: parseMonth,
    format: formatMonth,
  },
  [fieldsNames.year]: {
    parse: parseYear,
    format: formatYear,
  },
};
